import React from 'react'
import PropTypes from 'prop-types'
import { FlexByRow, XDivider, HalfScreen, YDivider } from '../../../../irmlib/src/styles'
import { MainRouteSubRoutePage } from '../../../AppControl/RoutePage'
import { ClearButton, SaveButton } from '../../../../irmlib/src/components/FormControls'
import { useSearchParams } from '../../../../irmlib/src/hooks'
// import * as regx from '../../../../irmlib/src/components/FormControls'
import ClosedJobData from './ClosedJobsData'
import { errorToast } from '../../../../common/functions'
import * as constants from '../../../../irmlib/src/common/constants'
import { useTranslation } from 'react-i18next'
import JobsFilter from '../JobsFilter'


// const formTemplate = [
//   {
//     label: '',
//     fieldKey: 'Search',
//     isRequired: true,
//     regx: regx.alphaRegex,
//     regxError: regx.alphaRegexError
//   },
// ]

const Buttons = props =>
  <>
    <ClearButton arrRefs={props.arrRefs} />
    <XDivider width='10px' />
    <SaveButton arrRefs={props.arrRefs} />
  </>

const VerticalDivider = () =>
  <YDivider height='15px' />

Buttons.propTypes = {
  arrRefs: PropTypes.array
}

// const getService = async () => {
//   const getObject = {
//     obj: {

//     }
//   }
//   return Promise.resolve(getObject)
// }

const ClosedJobs = (props) => {
  const { t } = useTranslation()

  // Get the search param from the path. If the status search param exists then set the initial jobStatus to that param.
  const emptyFilter = { deType: constants.defaultSelect, templateNAme: constants.defaultSelect, jobStatus: constants.defaultSelect, customer: constants.defaultForAccountLevel, orderNumber: constants.defaultForAccountLevel, districts: [constants.defaultSelect], initialStatus: 'APPROVED', userName: constants.defaultSelect, createDateFrom: constants.defaultSelect, createDateTo: constants.defaultSelect }
  const searchParams = useSearchParams()?.get('status')
  const statusNavParam = searchParams || 'Transmitted'
  
  // const chipsPersist = window.sessionStorage.getItem('persist-filters-AllJobs')
  // const [chipData, setChipData] = React.useState(searchParams ? dataFilter2 : chipsPersist1 || dataFilter)
  // const refLocalBusyCursor = useRef(null)
  // const [TextValue, setTextValue] = React.useState(null)
  const [val, Setval] = React.useState({ ...emptyFilter, jobStatus: statusNavParam, initialStatus: statusNavParam === constants.defaultSelect ? 'NoApprove' : 'APPROVED' })

  // const [arrRefs, data] = useFormPageHandler({
  //   formTemplate,
  //   service: getService,
  //   busyOverride: refLocalBusyCursor,
  // })

  const completedJobStatus = [
    { value: constants.jobStatus.cancel, label: t(`jobStatusObj.${constants.jobStatus.cancel}`) },
    { value: constants.jobStatus.transmitted, label: t(`jobStatusObj.${constants.jobStatus.transmitted}`) },
  ]

  const DefaultCompletedJobStatus = [ 
    // t(`jobStatusObj.${constants.jobStatus.transmitted}`),
    constants.jobStatus.transmitted,
  ]

  const getSelectedData = (data) => {
    if (data.District) {
      if (data.District.length) {
        if (data.District.length > 7) {
          errorToast({ message: t('toast.districtSelection'), title: t('toast.failedToFetch'), autoHideDuration: 3000, isBlocking: false })
        } else {
          if (data.Status) {
            if (data.Status.length) {
              Setval({ ...val, jobStatus: data.Status, districts: data.District, initialStatus: 'APPROVED' })
            } else {
              errorToast({ message: t('toast.invalidStatus'), title: t('toast.error'), autoHideDuration: 3000, isBlocking: false })
            }
          } else {
            Setval({ ...val, districts: data.District })
          }
        }
      } else {
        errorToast({ message: t('toast.invalidDistrict'), title: t('toast.error'), autoHideDuration: 3000, isBlocking: false })
      }
    } else if (data.Status) {
      if (data.Status.length) {
        Setval({ ...val, jobStatus: data.Status, initialStatus: 'APPROVED' })
      } else {
        errorToast({ message: t('toast.invalidStatus'), title: t('toast.error'), autoHideDuration: 3000, isBlocking: false })
      }
    }
  }

  return (
    <MainRouteSubRoutePage
      mainTitle='routeTitles.jobManagement'
      // subTitle='routeTitles.viewJobs'
    >
      <FlexByRow>
        <HalfScreen>
          <React.Fragment>
            <FlexByRow>
              <JobsFilter defaultStatus={DefaultCompletedJobStatus} activeStatus={completedJobStatus} selectedData = {getSelectedData} selectedStatus={Array.isArray(val.jobStatus) ? val.jobStatus : [val.jobStatus]}/>
            </FlexByRow>
          </React.Fragment>
        </HalfScreen>
      </FlexByRow>
      <VerticalDivider/>
      <ClosedJobData filterData={val} />
    </MainRouteSubRoutePage>
  )
}

export default ClosedJobs
